<template>
    <div>
        <v-form-message
                id="form-success"
                :message="objectSuccess"
                type="success"
                :isVisible="objectSuccess !== null"
                :auto-close-timeout="autoCloseTimeout"/>
        <div class="dialog" :class="{ 'active' : isVisible }">
            <div class="dialog--content dialog--content-default">
                <h2>{{ getPageTitle }}</h2>
                <form action method="POST" novalidation @submit="onSubmitObject">
                    <div class="form-message form-message--error" v-if="objectError !== null">{{ objectError }}</div>
                    <div v-else class="form-group" :class="{ 'form-group--error' : $v.object.file.$error }">
                        <input
                                type="text"
                                name="file"
                                class="form-control form-control--file"
                                role="button"
                                :aria-label="$t('form.upload.file.plc')"
                                aria-controls="filename"
                                :placeholder="$t('form.upload.file.plc')"
                                v-model="$v.object.file.$model.name"
                                autocomplete="false"
                                readonly
                                @click="choseFiles"
                        />
                        <input
                                type="file"
                                name="file"
                                aria-hidden="true"
                                tabindex="-1"
                                class="form-control"
                                autocomplete="false"
                                ref="file"
                                @change="onChangeFile"
                        />
                    </div>
                    <div class="form-group">
                        <button
                                role="button"
                                type="submit"
                                class="button"
                                :title="$t('form.upload.create')"
                                :disabled="objectFormDisabled"
                        >{{ $t('form.upload.create') }}
                        </button>
                    </div>
                </form>
                <button class="close-button" @click="onClickAction('close')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import FormMessage from './Forms/FormMessage';

export default {
    components: {
        vFormMessage: FormMessage
    },
    props: {
        fileExt: {
            type: Array,
            default: () => ['xlsx']
        },
        commentIsVisible: {
            type: Boolean,
            default: true
        },
        isVisible: {
            type: Boolean,
            default: false
        },
        value: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            objectError: null,
            objectSuccess: null,
            objectFormDisabled: false,
            autoCloseTimeout: 3000,
            object: {
                id: 0,
                file: {},
            }
        };
    },
    watch: {
        value: {
            handler: function (newVal, oldVal) {
                this.object = {
                    id: newVal.id || 0,
                    file: newVal.file || {},
                };
            },
            deep: true
        }
    },
    computed: {
        getPageTitle: function () {
            return this.$t("form.upload.create.title");
        },
        getValidFileExt: function () {
            return this.fileExt.length > 0 ? this.fileExt : this.$helpers.uploads
        }
    },
    validations: function () {
        return {
            object: {
                file: {
                    required,
                    isValidFile: value => {
                        if (value && value.name) {
                            return (
                                -1 !==
                                this.getValidFileExt.indexOf(
                                    value.name
                                        .split(".")
                                        .pop()
                                        .toLowerCase()
                                )
                            );
                        }
                        return false;
                    },
                }
            }
        };
    },
    methods: {
        choseFiles: function () {
            let fileInputElement = this.$refs.file;
            fileInputElement.click();
        },
        onSubmitObject: function (event) {
            event.preventDefault();

            this.objectError = null;
            this.objectFormDisabled = true;

            this.$v.object.$touch();
            if (this.$v.object.$invalid) {
                this.objectError = this.$t("form.error_form");
                this.objectFormDisabled = false;
            } else {
                let promise = this.$api
                    .clearParams()
                    .post("uploads/risk", this.$api.getFormData(this.object), {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    });

                promise
                    .then(
                        (response => {
                            this.objectError = "";
                            this.objectFormDisabled = false;

                            this.$emit("onAction", "upload", this.object);
                            this.objectSuccess = this.$t('form.upload.create.success');
                            this.onCloseDialog();
                        }).bind(this)
                    )
                    .catch(
                        (error => {
                            this.objectError = this.$t(error.response.data.message);
                            this.objectFormDisabled = false;
                        }).bind(this)
                    );
            }
        },
        onChangeFile: function (value) {
            if (value.currentTarget.files[0]) {
                this.object.file = value.currentTarget.files[0];
            }
        },
        onOpenDialog: function () {
            this.isVisible = true;

            this.onResetDialog();
        },
        onCloseDialog: function () {
            this.isVisible = false;

            setTimeout((function () {
                this.onResetDialog();
            }).bind(this), this.autoCloseTimeout)
        },
        onResetDialog: function () {
            this.objectError = null;
            this.objectSuccess = null;
            this.objectFormDisabled = false;
            this.object = {
                id: 0,
                file: {},
                comment: ""
            };

            this.$v.object.$reset();
        },
        onClickAction: function (action) {
            this.onCloseDialog();

            this.$emit("onAction", action);
        }
    }
};
</script>